module.exports = __webpack_public_path__ + "img/logo.6ef75b7d.png";